import * as React from "react";

import { useMyBagPresentationModel } from "../providers";

import { ApplyACoupon } from "../apply-a-coupon";

export const MyBagPromoCode: React.FunctionComponent = () => {
  const { presentationMyBagOrder } = useMyBagPresentationModel();

  const [shouldAccordionContentBeOpen, setShouldAccordionContentBeOpen] =
    React.useState(false);

  const handleAccordionHeaderClick: React.MouseEventHandler<HTMLDivElement> =
    React.useCallback(
      (event) => {
        event.preventDefault();
        setShouldAccordionContentBeOpen(!shouldAccordionContentBeOpen);
      },
      [shouldAccordionContentBeOpen, setShouldAccordionContentBeOpen]
    );

  if (!presentationMyBagOrder) {
    return null;
  }

  return (
    <section className="my-bag-promo-code">
      <div
        className={`accordion-header ${
          shouldAccordionContentBeOpen ? "open" : "closed"
        }`}
        onClick={handleAccordionHeaderClick}
      >
        <p>{`Got a promo code?`}</p>
      </div>
      <div
        className={`accordion-content ${
          shouldAccordionContentBeOpen ? "open" : "closed"
        }`}
      >
        <p>{`Conditions apply based on promotion.`}</p>
        <ApplyACoupon />
      </div>
    </section>
  );
};
